import React from 'react';
import HomeSectionTitle from './HomeSectionTitle';
import { downloadApp as styles, homeText } from './styles';
import { configs } from '../../configs';

const showMobileNav = () => window.innerWidth < 700;

const DownloadApp = (props) => {
  const {
    t
  } = props;
  const _s = styles(showMobileNav());
  const textStyles = homeText(showMobileNav());

  return (
    <section style={ _s.container } id="download-app">
      <div style={ _s.innerContainer }>
        <div className="container">
          <div style={_s.linkContainer(showMobileNav())}>
            <img
              style={showMobileNav()  ? _s.imageMobile : _s.image(props.isMobile)}
              src={`${configs.cdnUrl}/images/home/iPhone6.png`}
              role="presentation"
            />
          </div>
          <div style={ _s.titleContainer }>
              <HomeSectionTitle
                id="download-app"
                title={'Athlinks App'}
                subtitle={t('Your Results in Your Pocket')}
                {...props}
              />
          </div>

          <p style={{ ...textStyles.homeBody, ..._s.bodyCopyContainer }}>
            {t('With the Athlinks App, you\'ll have your Athlinks profile in'
              + ' your pocket and can quickly claim past results, compare stats with'
              + ' friends and rivals, and plan your next event — all on the go.')}
          </p>
          <div style={_s.linkContainer(showMobileNav())}>
            <a id="download-app-store"
              href="https://itunes.apple.com/us/app/athlinks/id1153823287?mt=8"
              target="_blank">
                <img src={`${configs.cdnUrl}/images/links/app-download.png`}
                  width={134}
                  height={40}
                  style={{display:'inline-block'}}/>
            </a>
            <a id="download-google-play"
              href="https://play.google.com/store/apps/details?id=com.athlinksmobile"
              target="_blank"
              style={{ marginLeft: 10, display:'inline-block' }}>
                <img src={`${configs.cdnUrl}/images/links/android-download.png`}
                  width={134}
                  height={40} />
            </a>
          </div>
        </div>
      </div>
    </section>
  )
};

export { DownloadApp };



/** WEBPACK FOOTER **
 ** ./components/home/DownloadApp.js
 **/